/**
 * The ONE list of /compare/* pages. The /compare hub (cards + ItemList
 * JSON-LD), the footer, the HTML sitemap page, and the "other comparisons"
 * links on each compare page all read from here, so adding a page is one entry
 * plus its route in App.tsx (public/sitemap.xml and public/llms.txt are static
 * files and need the URL added by hand; compare.test.tsx checks both).
 *
 * LEGAL: competitor names are used nominatively, to say what a page is about.
 * Never put a claim about a competitor's product, pricing, features, or
 * quality in this file or in any compare page.
 */
export interface CompareEntry {
  slug: string;
  competitor: string;
  /** Hub card blurb: about the evaluation angle, never about the competitor. */
  blurb: string;
}

export const COMPARE_PAGES: CompareEntry[] = [
  {
    slug: "rxpertise-alternative",
    competitor: "RxPertise",
    blurb: "Weighing a change of MRR platform: the end-to-end monthly loop, from chart to signed and invoiced review.",
  },
  {
    slug: "gerimed-alternative",
    competitor: "GeriMed",
    blurb: "A geriatric-care lens: Beers, STOPP, anticholinergic burden, and gradual dose reduction tracking.",
  },
  {
    slug: "profiles-360-alternative",
    competitor: "Profiles 360",
    blurb: "From reviewing a medication profile to closing the loop: prescriber response, DON sign-off, and audit trail.",
  },
  {
    slug: "frameworkrxp-alternative",
    competitor: "FrameworkRxP",
    blurb: "Chart-review automation criteria: ingest, rules and AI flags, e-signature, and invoicing in one place.",
  },
];

export const comparePath = (slug: string) => `/compare/${slug}`;
